export default __webpack_public_path__ + "static/media/category-for-her.fafa4401.png";